@ns-focus: var(--teal-plus-1);
@ns-hover: var(--teal-plus-1);
@ns-colour: var(--white);
@plus_icon: 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none"><path d="M18.7458 13.5365H13.5374V18.7448C13.5374 19.0211 13.4277 19.286 13.2323 19.4814C13.037 19.6767 12.772 19.7865 12.4958 19.7865C12.2195 19.7865 11.9545 19.6767 11.7592 19.4814C11.5638 19.286 11.4541 19.0211 11.4541 18.7448V13.5365H6.24577C5.9695 13.5365 5.70455 13.4267 5.5092 13.2314C5.31385 13.036 5.2041 12.7711 5.2041 12.4948C5.2041 12.2185 5.31385 11.9536 5.5092 11.7582C5.70455 11.5629 5.9695 11.4531 6.24577 11.4531H11.4541V6.24479C11.4541 5.96852 11.5638 5.70357 11.7592 5.50822C11.9545 5.31287 12.2195 5.20312 12.4958 5.20312C12.772 5.20312 13.037 5.31287 13.2323 5.50822C13.4277 5.70357 13.5374 5.96852 13.5374 6.24479V11.4531H18.7458C19.022 11.4531 19.287 11.5629 19.4823 11.7582C19.6777 11.9536 19.7874 12.2185 19.7874 12.4948C19.7874 12.7711 19.6777 13.036 19.4823 13.2314C19.287 13.4267 19.022 13.5365 18.7458 13.5365Z" fill="black" stroke="white"/></svg>';
@plus_icon_hover: 'data:image/svg+xml,<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.7458 13.5365H13.5374V18.7448C13.5374 19.0211 13.4277 19.286 13.2323 19.4814C13.037 19.6767 12.772 19.7865 12.4958 19.7865C12.2195 19.7865 11.9545 19.6767 11.7592 19.4814C11.5638 19.286 11.4541 19.0211 11.4541 18.7448V13.5365H6.24577C5.9695 13.5365 5.70455 13.4267 5.5092 13.2314C5.31385 13.036 5.2041 12.7711 5.2041 12.4948C5.2041 12.2185 5.31385 11.9536 5.5092 11.7582C5.70455 11.5629 5.9695 11.4531 6.24577 11.4531H11.4541V6.24479C11.4541 5.96852 11.5638 5.70357 11.7592 5.50822C11.9545 5.31287 12.2195 5.20312 12.4958 5.20312C12.772 5.20312 13.037 5.31287 13.2323 5.50822C13.4277 5.70357 13.5374 5.96852 13.5374 6.24479V11.4531H18.7458C19.022 11.4531 19.287 11.5629 19.4823 11.7582C19.6777 11.9536 19.7874 12.2185 19.7874 12.4948C19.7874 12.7711 19.6777 13.036 19.4823 13.2314C19.287 13.4267 19.022 13.5365 18.7458 13.5365Z" fill="black" stroke="%2371FFED"/></svg>';
@minus_icon: 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="21px" height="1px" viewBox="0 0 21 1" version="1.1"><!-- Generator: Sketch 51.3 (57544) - http://www.bohemiancoding.com/sketch --><title>Rectangle 5</title><desc>Created with Sketch.</desc><defs/><g id="FINAL" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="NOTICE-STRIP" transform="translate(-710.000000, -1590.000000)" fill="%23000"><g id="Desktop---Expanded" transform="translate(0.000000, 1138.000000)"><g id="STRIP-CROSS-BUTTON_MINUS" transform="translate(698.000000, 430.000000)"><g id="Group-15-Copy" transform="translate(12.000000, 12.000000)"><rect id="Rectangle-5" x="0" y="10" width="21" height="1"/></g></g></g></g></g></svg>';

.notice-strip__wrapper {
  .banner-area {
    max-height: 0;
    overflow: hidden;
  }

  .notice-strip {
    font-family: 'Matter SQ','Arial Fallback', sans-serif;
    background: @ns-colour;
    border: none;
    cursor: pointer;
    position: relative;
    margin: 0;
    min-height: 40px;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    z-index: 11;
    border-bottom: 1px solid var(--black);
    padding: 8px 0;

    span {
      display: block;
      font-weight: 500;
      color: var(--black);
      text-align: center;
      line-height: 18px;
      max-width: 700px;
      font-size: 15px;
    }

    &:after {
      content: '';
      width: 22px;
      height: 22px;
      background: transparent url(@plus_icon) no-repeat center;
      left: 50%;
      margin-left: -11px;
      position: absolute;
      display: block;
      bottom: -14px;
      transition: 0.3s transform ease-in;
      animation: 0.3s notice-strip-spin ease-in;
      z-index: 99;
    }

    &:before {
      content: '';
      width: 44px;
      height: 22px;
      background-color: @ns-colour;
      border-radius: 0 0 22px 22px;
      border: 1px solid var(--black);
      left: 50%;
      margin-left: -22px;
      position: absolute;
      display: block;
      bottom: -23px;
      border: 1px solid var(--black);
      border-top: 1px solid @ns-colour;
      box-sizing: content-box;
    }

    &:focus,
    &:focus:before,
    &:focus:after {
      background-color: @ns-focus;
      border-top-color: @ns-focus;
    }

    &:hover,
    &:hover:before,
    &:hover:after {
      background-color: @ns-hover;
    }
    &:hover:after {
      transform: rotate(90deg);
    }
    &:hover:before {
      border-top: 1px solid var(--teal-plus-1);
    }

    &:hover:after,
    &:focus:after {
      background: transparent url(@plus_icon_hover) no-repeat center;
    }
  }

  & .banner-area {
    display: none;
  }

  &.expanded {
    .banner-area {
      max-height: 100%;
      display: block;
    }

    .notice-strip:after {
      background: transparent url(@minus_icon) no-repeat center;
      width: 17px;
      margin-left: -8px;
    }

    .notice-strip:hover,
    .notice-strip:hover:before,
    .notice-strip:hover:after {
      background-color: @ns-hover;
    }

    .notice-strip:focus,
    .notice-strip:focus:before,
    .notice-strip:focus:after {
      background-color: @ns-focus;
    }

    .notice-strip:hover:after {
      transform: none;
    }
  }
}

@keyframes notice-strip-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(-180deg);
  }
}

@animated_border_colour: @ig-red;
@animation_duration: 3s;
@animation_height: 300px;
@border_colour: gray;
@text_transition: bottom 0.5s ease-out;

@keyframes slide {
  to {
    bottom: 0;
  }
}
@keyframes slide-out {
  to {
    bottom: -100px;
  }
}

/* Set override class */
.notice-strip__wrapper--multi {
  .image-background div.c-hidden {
    border-top: 1px solid @border_colour;
  }
  .op-textAnimation {
    min-height: @animation_height;
    position: relative;
  }
}
.op-inText {
  position: absolute;
  transition: @text_transition;
  &.animated {
    animation-duration: @animation_duration;
    animation-name: slide;
  }
  &.animated-out {
    animation-duration: @animation_duration;
    animation-name: slide-out;
  }
  .simple-text p,
  .cta.section {
    opacity: 0;
    transition: opacity 0.5s ease-out;
  }
}
@media (max-width: 600px) {
  .notice-strip__wrapper {
    .cta.link--dark:hover,
    .cta.link--dark h3:hover,
    .cta.link-arrow--dark:hover {
      text-decoration: none;
    }
  }
  .notice-strip__wrapper--multi .multipromo-col {
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
}
